import {
    RESERVE_PRODUCE_SUBMIT_REQUEST,
    RESERVE_PRODUCE_SUBMIT_SUCCESS,
    RESERVE_PRODUCE_SUBMIT_ERROR,
    RESERVE_PRODUCE_CHANGE_SELECTED_COUNT,
} from 'state/actions/reserve_produce'

const initialState = {
    selectedCount: 1,
    submitting: false,
    errorMessage: '',
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case RESERVE_PRODUCE_CHANGE_SELECTED_COUNT:
        return {
            ...state,
            selectedCount: action.payload.selectedCount,
        }
    case RESERVE_PRODUCE_SUBMIT_REQUEST:
        return {
            ...state,
            errorMessage: '',
            submitting: true,
        }
    case RESERVE_PRODUCE_SUBMIT_SUCCESS:
        return {
            ...state,
            submitting: false,
        }
    case RESERVE_PRODUCE_SUBMIT_ERROR:
        return {
            ...state,
            submitting: false,
            errorMessage: action.payload.errorMessage,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/reserve_produce.js